import { useGetOne } from 'react-admin';
import { COMPANIES } from '@/utils/CONST';

interface Params {
    companyUriId: string;
}

const useGetCompany = ({ companyUriId }: Params) => {
    const { data, isLoading, refetch }: any = useGetOne(
        COMPANIES,
        {
            id: companyUriId,
        },
        {
            enabled: companyUriId !== undefined && companyUriId !== null,
        },
    );

    return {
        company: data,
        isLoading,
        refetch,
    };
};

export default useGetCompany;
